import React, { useEffect } from "react";
import {
	HashRouter as Router,
	Route,
	Switch,
} from "react-router-dom";
import Toolbar from "./app/components/toolbar/Toolbar";

//Paginas
import Welcome from "./app/pages/Welcome/Index";
import Error from "./app/pages/Error/Index";
import NotFound from "./app/pages/NotFound/Index";
import First from "./app/pages/First/Index";
import Third from "./app/pages/Third/Index";
import NoticesHub from "./app/pages/NoticesHub/Index";
import Faq from "./app/pages/Faq/Index";
import Notices from "./app/pages/Notices/Index";
import Notice from "./app/pages/Notices/Detail";
import CookiesTerms from "./app/pages/CookiesTerms/Index";
import PrivacyPolicy from "./app/pages/PrivacyPolicy/Index";
import TermOfUse from "./app/pages/TermOfUse/Index";

import quadrados from "./app/assets/images/quadrados.png";

function Routes(props) {
	useEffect(() => {
		var hidden, visibilityChange;
		if (typeof document.hidden !== "undefined") {
			hidden = "hidden";
			visibilityChange = "visibilitychange";
		} else if (typeof document.mozHidden !== "undefined") {
			hidden = "mozHidden";
			visibilityChange = "mozvisibilitychange";
		} else if (typeof document.msHidden !== "undefined") {
			hidden = "msHidden";
			visibilityChange = "msvisibilitychange";
		} else if (typeof document.webkitHidden !== "undefined") {
			hidden = "webkitHidden";
			visibilityChange = "webkitvisibilitychange";
		}

		function handleVisibilityChange() {
			var element = document.activeElement;
			element.blur();
			element.focus();
		}

		document.addEventListener(
			visibilityChange,
			handleVisibilityChange,
			false
		);
	}, []);

	return (
		<>
			<Router style={{ height: "100%" }}>
				<Toolbar />
				<Switch>
					<Route
						path="/bem-vindo"
						component={(props) => <Welcome {...props} />}
					/>
					<Route
						exact
						path="/"
						component={(props) => <First {...props} />}
					/>
					<Route
						path="/seja-um-parceiro"
						component={(props) => <Third {...props} />}
					/>
					<Route
						path="/central-de-noticias"
						component={(props) => <NoticesHub {...props} />}
					/>
					<Route
						path="/faq"
						component={(props) => <Faq {...props} />}
					/>
					<Route
						path="/noticias"
						component={(props) => <Notices {...props} />}
					/>
					<Route
						path="/noticia/:id"
						component={(props) => <Notice {...props} />}
					/>
					<Route
						path="/politica-de-cookies"
						component={(props) => <CookiesTerms {...props} />}
					/>
					<Route
						path="/politica-de-privacidade"
						component={(props) => <PrivacyPolicy {...props} />}
					/>
					<Route
						path="/termo-de-uso"
						component={(props) => <TermOfUse {...props} />}
					/>
					<Route
						path="/erro"
						component={(props) => <Error {...props} />}
					/>
					<Route component={(props) => <NotFound {...props} />} />
				</Switch>
			</Router>
			<img
				id={"quadrados"}
				className="quadrados"
				src={quadrados}
				alt=""
				style={{ display: "none" }}
			/>
		</>
	);
}

export function backPage(reference) {
	if (localStorage.getItem("ActualPage") !== reference.location.pathname) {
		if (localStorage.getItem("BackPage") != null) {
			let historic = JSON.parse(localStorage.getItem("BackPage"));
			if (historic[historic.length - 1] !== reference.location.pathname) {
				historic.push(localStorage.getItem("ActualPage"));
				localStorage.setItem("BackPage", JSON.stringify(historic));
			} else {
			}
		} else {
			let historic = [];
			historic.push("/");
			localStorage.setItem("BackPage", JSON.stringify(historic));
		}
		localStorage.setItem("ActualPage", reference.location.pathname);
	}
}

export function publicArea() {
	document.getElementById("background").style.display = "none";
	document.getElementById("quadrados").style.display = "none";
	document.getElementById("toolbar_container").style.position = "fixed";
	document.getElementById("toolbar_container").style.width = "100%";
}

export function LoguedArea() {
	document.getElementById("background").style.backgroundColor = "#2e2b84";
	document.getElementById("background").style.display = "block";
	document.getElementById("quadrados").style.display = "block";
	document.getElementById("toolbar_container").style.position = "relative";
	document.getElementById("toolbar_container").style.width = "auto";
}

export default Routes;
